import {
    MeshStandardMaterial,
    MeshLambertMaterial,
    MeshPhongMaterial,
    LineBasicMaterial,
    PointsMaterial,
    DoubleSide,
    MeshBasicMaterial,
    Color
} from "three"

/*****************************************************************
 * Material Provider
 * ***************************************************************/

export const raycastMaterial = new MeshBasicMaterial({
    color: 0x00ff00,
    side: DoubleSide,
    //depthTest: false
});

/**
 * point Material
 */
export const dotMaterial = new PointsMaterial({
    size: 5,
    sizeAttenuation: false,
    color: 0x888888
})

export const smallDotMaterial = new PointsMaterial({
    size: 1.25,
    vertexColors: true,
})

/**
 * line Material
 */
export const lineMaterial = new LineBasicMaterial({
    color: 0x00ceff
})

/**
 * Basic Material
 */
export const meshMaterial = new MeshLambertMaterial({
    color: 0x555555,
})

/**
 * Malocclusion Tooth Material
 */
export const toothMalocMaterial = new MeshStandardMaterial({
    color: 0x3a7579,
    metalness: 0,
    roughness: 0.3,
    opacity: 0.8,
    transparent: true,
    polygonOffset: true,
    polygonOffsetFactor: -0.5,
    polygonOffsetUnits: 0.1,
})

/**
 * Setup Tooth Material
 */
export const toothSetupMaterial = new MeshStandardMaterial({
    color: 0x0a9454,
    metalness: 0,
    roughness: 0.3,
    opacity: 0.8,
    transparent: true,
    polygonOffset: true,
    polygonOffsetFactor: -0.5,
    polygonOffsetUnits: 0.1,
})


/**
 * tooth Material
 */
export const toothMaterial = new MeshStandardMaterial({
    color: 0xfbf9f5,
    metalness: 0.2,
    roughness: 0.4,
    opacity: 1,
    transparent: false,
})

/**
 * selected tooth Material
 */
export const verticeToothMaterial = new MeshStandardMaterial({
    color: 0xfbf9f5,
    metalness: 0.2,
    roughness: 0.4,
    transparent: false,
    vertexColors: true,
    opacity: 1,
})

/**
 * selected tooth Material
 */
export const beigeToothMaterial = new MeshStandardMaterial({
    color: 0xfaebd2, //250 235 210
    metalness: 0.2,
    roughness: 0.4,
    transparent: false,
    opacity: 1,
})

/**
 * pontic Material
 */
export const ponticMaterial = new MeshStandardMaterial({
    color: 0xfbf9f5,
    transparent: true,
    opacity: 0.8,
    metalness: 0.4,
    roughness: 0.3
})

/**
 * Gengiva Material
 */
export const gengivaMaterial = geom => new MeshStandardMaterial({
    color: 0xA53E40,
    metalness: 0,
    roughness: 0.35,
    side: DoubleSide,
})

/**
 * Cone Material
 */
export let coneMaterial = () => new MeshStandardMaterial({
    color: 0xF86600,
    metalness: 0.35,
    roughness: 0.5,
    side: DoubleSide
})

/**
 * Attachment Positive Material
 */
export const attachmentPosMaterial = new MeshStandardMaterial({
    color: 0xFFEBBE,
    metalness: 0.2,
    roughness: 0
})

/**
 * Attachment Negative Material
 */
export const attachmentNegMaterial = new MeshStandardMaterial({
    color: 0xFFEBBE,
    metalness: 0.2,
    roughness: 0
})

/**
 * Stripping Material
 */
export const strippingMaterial = new MeshPhongMaterial({
    color: 0x03fc03,
    specular: 0x000000,
    polygonOffset: true,
    polygonOffsetFactor: -0.5,
    polygonOffsetUnits: 0.1,
})

export const randomColorMaterial = () => new MeshBasicMaterial({
    color: new Color(Math.random(), Math.random(), Math.random()),
    side: DoubleSide,
});
